import { render, staticRenderFns } from "./ComplaintManage.vue?vue&type=template&id=2b7c4d6b&scoped=true"
import script from "./ComplaintManage.vue?vue&type=script&lang=js"
export * from "./ComplaintManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7c4d6b",
  null
  
)

export default component.exports